<!-- Container -->
<div class="kt-container-fixed flex items-center justify-between flex-wrap gap-3">
	Page content
</div>
<!-- End of Container -->